export class Player {
    constructor(
        public playerName: string,
        public wins?: number,
        public losses?: number,
        public playerBio?: string 
    ){}
}